/**
 * @name clock-arrow-right
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY2bDIgMSIgLz4KICA8cGF0aCBkPSJNMTMuNSAyMS44ODVBMTAgMTAgMCAxIDEgMjIgMTIiIC8+CiAgPHBhdGggZD0iTTE0IDE4aDgiIC8+CiAgPHBhdGggZD0ibTE4IDIyIDQtNC00LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/clock-arrow-right
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const ClockArrowRight: string = `
<svg
  class="lucide lucide-clock-arrow-right"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 6v6l2 1" />
  <path d="M13.5 21.885A10 10 0 1 1 22 12" />
  <path d="M14 18h8" />
  <path d="m18 22 4-4-4-4" />
</svg>
`;

export default ClockArrowRight;
